<div class="p-6">
    <div [formGroup]="form" class="mt-4 mx-auto">
        <div class="flex w-12/12  justify-between items-center mb-4 ">
            <h4>Editar Passageiro OS</h4>
            <button mat-icon-button (click)="closeModal()" class="btn-close">
                <mat-icon>close</mat-icon>

            </button>
        </div>

        <!-- @if (checkPermission('criar')) {
    <button class="btn-add mdc-button mr-8 mdc-button--raised mat-mdc-raised-button mat-unthemed mat-mdc-button-base"
      (click)="openPassengerForm()">
      <span class="mat-mdc-button-persistent-ripple mdc-button__ripple"></span>
      <span class="mdc-button__label">Novo</span>
      <span class="mat-focus-indicator"></span>
      <span class="mat-mdc-button-touch-target"></span>
      <span class="mat-ripple mat-mdc-button-ripple"></span>
    </button>
  } -->
        <div class="flex flex-row justify-around items-center gap-x-4 w-full">
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline">
                <mat-label>Nome Passageiro</mat-label>
                <input matInput formControlName="nomePassageiro" />
            </mat-form-field>

            <!-- <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Tipo Doc</mat-label>
                <mat-select formControlName="tipoDocumento" (selectionChange)="onDocumentTypeChange($event.value)">
                    <mat-option *ngFor="let document of documentTypeList" [value]="document.id">
                        {{ document.descricao }}
                    </mat-option>
                </mat-select>

            </mat-form-field> -->
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Número Doc</mat-label>
                <input matInput formControlName="numeroDoc" [mask]="documentMask" />
            </mat-form-field>
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Contato</mat-label>
                <input matInput formControlName="contato" />
            </mat-form-field>
        </div>

        <div class="p-4">
            <mat-divider></mat-divider>
        </div>

        <div class="flex flex-row justify-around items-center gap-x-4 mt-3 w-full">
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Companhia</mat-label>
                <input matInput formControlName="companhia" />
            </mat-form-field>
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Hora Saída</mat-label>
                <input matInput formControlName="horaSaida" type="time" />
            </mat-form-field>
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Hora Chegada</mat-label>
                <input matInput formControlName="horaChegada" type="time" />
            </mat-form-field>
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Vôo</mat-label>
                <input matInput formControlName="voo" />
            </mat-form-field>

        </div>

        <div class="flex flex-row justify-end items-end gap-5 mr-2">
            <button mat-flat-button class="btn-tg" (click)="cancel()">
                Cancel
            </button>
            <button mat-flat-button class="btn-tg" [disabled]="form.invalid || loading" *ngIf="editIndex === null"
                (click)="editItem()">
                @if (loading) {
                <mat-spinner diameter="22" class="loading-spinner" selected-track-color="red"></mat-spinner>
                } @else {
                Editar
                }
            </button>
        </div>

    </div>


</div>